import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './RenaPortfolio.css';

function RenaPortfolio() {
  const [modalImage, setModalImage] = useState(null);

  const openModal = (src) => {
    setModalImage(src);
  };

  const closeModal = () => {
    setModalImage(null);
  };

  return (
    <div className="portfolio-page rena-portfolio">
      {modalImage && (
        <div className="image-modal" onClick={closeModal}>
          <div className="modal-content">
            <span className="modal-close">&times;</span>
            <img src={modalImage} alt="Showcase" />
          </div>
        </div>
      )}
      <section className="portfolio-hero">
        <div className="container">
          <div className="profile-header">
            <img 
              src="https://tr.rbxcdn.com/30DAY-AvatarHeadshot-D2D9822EB0A48BC2B7AAAC8FB0E54BD5-Png/150/150/AvatarHeadshot/Webp/noFilter"
              alt="rena"
              className="profile-avatar"
            />
            <div className="profile-info">
              <h1>rena (pwawli)</h1>
              <p className="profile-role">@pwawli</p>
              <div className="profile-bio-section">
                <h3>Bio</h3>
                <p>
                  Hii! I'm Rena, I'm 17, and I love building, designing UI, making animations, and creating clothing on Roblox. I also have experience on Blender.
                </p>
                <p>
                  I started earlier this year and I'm looking to keep improving, gain more experience, and work with people who enjoy creating as much as I do. I co-own MeowBox Studios with my boyfriend, and I'm the main builder and animator.
                </p>
                <p>
                  I work well both in groups and on my own, I communicate easily, and I usually answer pretty fast and I'm comfortable working on tight timelines.
                </p>
                <p>
                  My blue is pwawli. (DMs are open only for commissions and work.)
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="skills-section">
        <div className="container">
          <h2>What I Do</h2>
          <div className="skills-grid">
            <div className="skill-item">Building</div>
            <div className="skill-item">Animation</div>
            <div className="skill-item">UI Design</div>
            <div className="skill-item">Lighting</div>
            <div className="skill-item">Clothing Design</div>
            <div className="skill-item">Blender</div>
            <div className="skill-item">Level Design</div>
            <div className="skill-item">Props</div>
            <div className="skill-item">Environments</div>
          </div>
        </div>
      </section>

      <section className="showcase-section">
        <div className="container">
          <h3 className="showcase-category">Building - Collect a Cat</h3>
          <div className="showcase-grid">
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building%20(5)')}>
              <img src="https://cdn.meowboxstudios.com/rena/building%20(5)" alt="Collect a Cat 1" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building%20(6)')}>
              <img src="https://cdn.meowboxstudios.com/rena/building%20(6)" alt="Collect a Cat 2" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building%20(7)')}>
              <img src="https://cdn.meowboxstudios.com/rena/building%20(7)" alt="Collect a Cat 3" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building%20(8)')}>
              <img src="https://cdn.meowboxstudios.com/rena/building%20(8)" alt="Collect a Cat 4" />
            </div>
          </div>

          <h3 className="showcase-category">Building - Mr Kitty</h3>
          <div className="showcase-grid">
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building')}>
              <img src="https://cdn.meowboxstudios.com/rena/building" alt="Mr Kitty Building 1" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building%20(2)')}>
              <img src="https://cdn.meowboxstudios.com/rena/building%20(2)" alt="Mr Kitty Building 2" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building%20(3)')}>
              <img src="https://cdn.meowboxstudios.com/rena/building%20(3)" alt="Mr Kitty Building 3" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building%20(4)')}>
              <img src="https://cdn.meowboxstudios.com/rena/building%20(4)" alt="Mr Kitty Building 4" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building%20(9)')}>
              <img src="https://cdn.meowboxstudios.com/rena/building%20(9)" alt="Mr Kitty Building 5" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/rena/building%20(10)')}>
              <img src="https://cdn.meowboxstudios.com/rena/building%20(10)" alt="Mr Kitty Building 6" />
            </div>
          </div>

          <h3 className="showcase-category">UI Design</h3>
          <div className="showcase-grid">
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/ui.png')}>
              <img src="https://cdn.meowboxstudios.com/ui.png" alt="UI Design 1" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/shop.png')}>
              <img src="https://cdn.meowboxstudios.com/shop.png" alt="Shop Interface" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/8155c4edb8e9ba5b2e72dbf6e2981675')}>
              <img src="https://cdn.meowboxstudios.com/8155c4edb8e9ba5b2e72dbf6e2981675" alt="UI Design 2" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/f67549322fb6af9a04b879412848b8cd')}>
              <img src="https://cdn.meowboxstudios.com/f67549322fb6af9a04b879412848b8cd" alt="UI Design 3" />
            </div>
          </div>

          <h3 className="showcase-category">Animations</h3>
          <div className="showcase-grid">
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/11d0ce2bdaf5c25ca424f3500355cbea')}>
              <img src="https://cdn.meowboxstudios.com/11d0ce2bdaf5c25ca424f3500355cbea" alt="Animation 1" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/cb7b4ba253bad7754644abc3620b96d7')}>
              <img src="https://cdn.meowboxstudios.com/cb7b4ba253bad7754644abc3620b96d7" alt="Animation 2" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/c98b6de73e7f36dea219c9c70ea12b01')}>
              <img src="https://cdn.meowboxstudios.com/c98b6de73e7f36dea219c9c70ea12b01" alt="Animation 3" />
            </div>
          </div>

          <h3 className="showcase-category">Clothing Design</h3>
          <div className="showcase-grid">
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/Screenshot_2025-11-16_at_5.58.35_AM.png')}>
              <img src="https://cdn.meowboxstudios.com/Screenshot_2025-11-16_at_5.58.35_AM.png" alt="Shirt 1" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/shirt')}>
              <img src="https://cdn.meowboxstudios.com/shirt" alt="Shirt 2" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/shirt%20(2)')}>
              <img src="https://cdn.meowboxstudios.com/shirt%20(2)" alt="Shirt 3" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/shirt%20(3)')}>
              <img src="https://cdn.meowboxstudios.com/shirt%20(3)" alt="Shirt 4" />
            </div>
            <div className="showcase-item" onClick={() => openModal('https://cdn.meowboxstudios.com/shirt%20(4)')}>
              <img src="https://cdn.meowboxstudios.com/shirt%20(4)" alt="Shirt 5" />
            </div>
          </div>
        </div>
      </section>

      <section className="projects-section">
        <div className="container">
          <h2>Projects</h2>
          <div className="projects-list">
            <div className="project-card">
              <h3>Pick up the Phone Horror</h3>
              <p className="project-role">Lead Builder & Environment Artist</p>
              <p className="project-description">
                a Game Based off the Blackphone 2 Horror..
              </p>
              <div className="project-tech">
                <span className="tech-tag">Roblox Studio</span>
                <span className="tech-tag">Level Design</span>
                <span className="tech-tag">Lighting</span>
                <span className="tech-tag">Environment Art</span>
              </div>
            </div>
            <div className="project-card">
              <h3>Level 974 – MrKitty's Home</h3>
              <p className="project-role">Lead Designer & Animator</p>
              <p className="project-description">
                Mr Kitty is a Backrooms Horror Game, we're actively working on this
              </p>
              <div className="project-tech">
                <span className="tech-tag">Building</span>
                <span className="tech-tag">Animation</span>
                <span className="tech-tag">Worldbuilding</span>
                <span className="tech-tag">Art Direction</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="experience-section">
        <div className="container">
          <h2>Experience</h2>
          <div className="experience-card">
            <h3>Co-Founder & Lead Builder</h3>
            <p className="experience-company">MeowBox Studios</p>
            <p className="experience-date">November 2025 - Present</p>
            <ul className="experience-details">
              <li>Co-founded Roblox horror development studio</li>
              <li>Lead environmental design and world creation</li>
              <li>Create atmospheric lighting and visual direction</li>
              <li>Design and build game environments and props</li>
              <li>Animate characters and creatures</li>
              <li>Establish studio's signature visual style</li>
            </ul>
          </div>
        </div>
      </section>

      <section className="links-section">
        <div className="container">
          <h2>Links</h2>
          <div className="links-grid">
            <a href="https://www.roblox.com/users/317565729/profile" className="link-btn" target="_blank" rel="noopener noreferrer">
              Roblox Profile
            </a>
            <a href="mailto:careers@meowboxstudios.com" className="link-btn">
              Contact Me
            </a>
            <Link to="/team" className="link-btn">
              Back to Team
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export default RenaPortfolio;
